import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateStepRequest = { steps: '_step' };
var _bulkCreateStepResponse = { results: '_bulkStepResult' };
var _bulkStepResult = { item: '_step' };
var _cloneStepRequest = {};
var _cloneStepResponse = { step: '_step' };
var _createStepRequest = { step: '_step' };
var _createStepResponse = { step: '_step' };
var _deleteStepRequest = {};
var _deleteStepResponse = {};
var _description = { image: '_image', video: '_videoV2' };
var _getStepRequest = {};
var _getStepResponse = { step: '_step' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _moveStepRequest = {};
var _moveStepResponse = { step: '_step' };
var _queryStepsRequest = {};
var _queryStepsResponse = { steps: '_step' };
var _queryStepsWithoutPagingRequest = {};
var _queryStepsWithoutPagingResponse = { steps: '_step' };
var _quiz = { passingGrade: 'google.protobuf.DoubleValue' };
var _step = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    ordering: 'DOUBLE',
    description: '_description',
    quiz: '_quiz',
};
var _updateStepRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    step: '_step',
};
var _updateStepResponse = { step: '_step' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
function resolveWixOnlineprogramsStepsV3StepsServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/program-steps-service',
                destPath: '',
            },
            {
                srcPath: '/_api/program-steps-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a Step. */
export function createStep(payload) {
    var _a = serializer(_createStepRequest, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createStepResponse, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.CreateStep',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createStep.fromReq = fromReq;
    __createStep.__isAmbassador = true;
    return __createStep;
}
export function bulkCreateStep(payload) {
    var _a = serializer(_bulkCreateStepRequest, { _description: _description, _image: _image, _quiz: _quiz, _step: _step, _videoResolution: _videoResolution, _videoV2: _videoV2 }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateStepResponse, {
        _bulkStepResult: _bulkStepResult,
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __bulkCreateStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.BulkCreateStep',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/bulk/steps/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateStep.fromReq = fromReq;
    __bulkCreateStep.__isAmbassador = true;
    return __bulkCreateStep;
}
/** Retrieves a Step. */
export function getStep(payload) {
    var _a = serializer(_getStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStepResponse, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'GET',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.GetStep',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStep.fromReq = fromReq;
    __getStep.__isAmbassador = true;
    return __getStep;
}
/** Update Step. */
export function updateStep(payload) {
    var _a = serializer(_updateStepRequest, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStepResponse, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'PATCH',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.UpdateStep',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{step.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStep.fromReq = fromReq;
    __updateStep.__isAmbassador = true;
    return __updateStep;
}
/**
 * Deletes a Step.
 * Deleting a Step permanently removes them from the Step List.
 */
export function deleteStep(payload) {
    var _a = serializer(_deleteStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteStepResponse, {}).fromJSON;
    function __deleteStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'DELETE',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.DeleteStep',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteStep.fromReq = fromReq;
    __deleteStep.__isAmbassador = true;
    return __deleteStep;
}
/** Query steps. */
export function querySteps(payload) {
    var _a = serializer(_queryStepsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStepsResponse, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __querySteps(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.QuerySteps',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __querySteps.fromReq = fromReq;
    __querySteps.__isAmbassador = true;
    return __querySteps;
}
export function queryStepsWithoutPaging(payload) {
    var _a = serializer(_queryStepsWithoutPagingRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStepsWithoutPagingResponse, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryStepsWithoutPaging(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.QueryStepsWithoutPaging',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/query/no-paging',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStepsWithoutPaging.fromReq = fromReq;
    __queryStepsWithoutPaging.__isAmbassador = true;
    return __queryStepsWithoutPaging;
}
/** Change Step position. */
export function moveStep(payload) {
    var _a = serializer(_moveStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moveStepResponse, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __moveStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'PATCH',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.MoveStep',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}/move',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moveStep.fromReq = fromReq;
    __moveStep.__isAmbassador = true;
    return __moveStep;
}
/** Clone Step. */
export function cloneStep(payload) {
    var _a = serializer(_cloneStepRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneStepResponse, {
        _description: _description,
        _image: _image,
        _quiz: _quiz,
        _step: _step,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
    }).fromJSON;
    function __cloneStep(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.online_programs.v3.step',
            method: 'POST',
            methodFqn: 'wix.onlineprograms.steps.v3.StepsService.CloneStep',
            url: resolveWixOnlineprogramsStepsV3StepsServiceUrl({
                protoPath: '/v3/steps/{stepId}/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneStep.fromReq = fromReq;
    __cloneStep.__isAmbassador = true;
    return __cloneStep;
}
//# sourceMappingURL=http.impl.js.map